<template>
  <div class="plugin-settings">
    <plugin-item-list-overview
        :isActive.sync="isActive"
        :pluginName="pluginName"
        :pluginDesc="pluginDesc"
        :pluginImgName="pluginImgName"
        :handle="handle"
        :can-edit="editPrivilege"
        has-modal-settings=true
        @open-modal="openModal"
        @update-is-active="updateActivationState"
    ></plugin-item-list-overview>
    <b-modal
        id="plugin-gated-content"
        content-class="plugin-modal"
        size="lg"
        centered
        ok-only
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        @ok="handleOk"
    >
      <template v-slot:modal-title>
        <h3>{{ $t('settings.plugins.gatedContent.modalTitle') }}</h3>
      </template>
      <b-row class="my-4">
        <b-col cols="12" offset-sm="1" sm="10">
          <p v-html="$t('settings.plugins.gatedContent.modalDesc')"></p>
        </b-col>
      </b-row>
      <component
        v-for="(configItem, index) in pluginFieldConfig"
        :key="index"
        :is="configItem.fieldType"
        :handle="configItem.handle"
        :label="configItem.title"
        :desc="configItem.desc"
        :value-from-db="settingsData[configItem.handle]"
        @update-field="updateSettingValue($event, configItem.handle)"
      />
      <template v-slot:modal-footer="{ ok }">
        <b-button
          @click="ok()"
          block
          class="p-3"
        >
          {{ $t('button.ok') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CheckboxRow from '@/components/helper/CheckboxRow.vue';
import PluginItemListOverview from '@/components/settings/plugins/PluginItemListOverview.vue';
import InputRow from '@/components/helper/InputRow.vue';

export default {
  name: 'PluginGatedContent',
  components: {
    PluginItemListOverview,
    CheckboxRow,
    InputRow,
  },
  props: {
    pluginData: {
      type: Object,
      default: null,
    },
    editPrivilege: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      handle: 'plugin_gated_content',
      pluginName: this.$t('settings.plugins.gatedContent.name'),
      pluginDesc: this.$t('settings.plugins.gatedContent.desc'),
      pluginImgName: 'gated_content.jpg',
      pluginFieldConfig: [
        {
          title: this.$t('settings.plugins.gatedContent.headlineLabel'),
          desc: this.$t('settings.plugins.gatedContent.headlineDesc'),
          fieldType: 'InputRow',
          handle: 'headline',
        },
        {
          title: this.$t('settings.plugins.gatedContent.textLabel'),
          desc: this.$t('settings.plugins.gatedContent.textDesc'),
          fieldType: 'InputRow',
          handle: 'text',
        },
        {
          title: this.$t('settings.plugins.gatedContent.toEmailLabel'),
          desc: this.$t('settings.plugins.gatedContent.toEmailDesc'),
          fieldType: 'InputRow',
          handle: 'toEmail',
        },
        {
          title: this.$t('settings.plugins.gatedContent.inputTextLabel'),
          desc: this.$t('settings.plugins.gatedContent.inputTextDesc'),
          fieldType: 'InputRow',
          handle: 'inputText',
        },
        {
          title: this.$t('settings.plugins.gatedContent.buttonTextLabel'),
          desc: this.$t('settings.plugins.gatedContent.buttonTextDesc'),
          fieldType: 'InputRow',
          handle: 'buttonText',
        },
        {
          title: this.$t('settings.plugins.gatedContent.pageLabel'),
          desc: this.$t('settings.plugins.gatedContent.pageDesc'),
          fieldType: 'InputRow',
          handle: 'page',
        },
        {
          title: this.$t('settings.plugins.gatedContent.showTimeLabel'),
          desc: this.$t('settings.plugins.gatedContent.showTimeDesc'),
          fieldType: 'InputRow',
          handle: 'showTime',
        },
      ],
      isActive: false,
      settingsData: {
        headline: null,
        text: null,
        toEmail: null,
        inputText: null,
        buttonText: null,
        page: '0',
        showTime: '2000',
      },
    };
  },
  created() {
    if (this.pluginData) {
      this.isActive = (this.pluginData && 'enabled' in this.pluginData)
        ? this.pluginData.enabled
        : this.isActive;
      this.settingsData = (
        this.pluginData && 'settings' in this.pluginData && Object.keys(this.pluginData.settings).length !== 0
      )
        ? { ...this.pluginData.settings }
        : { ...this.settingsData };
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show('plugin-gated-content');
    },
    updateSettingValue(value, handle) {
      if (handle in this.settingsData) {
        this.settingsData[handle] = value;
      }
    },
    handleOk() {
      this.updatePluginData();
    },
    updateActivationState(state) {
      this.isActive = state;
      if (state === true) {
        this.$bvModal.show('plugin-gated-content');
      }
      this.updatePluginData();
    },
    updateCheckbox(event) {
      this.settingsData.anomymizeIp = event;
    },
    updatePluginData() {
      const pluginDataObject = {
        handle: this.handle,
        enabled: this.isActive,
        settings: this.settingsData,
      };
      this.$emit('update-plugin-data', pluginDataObject);
    },
  },
};
</script>
